import React, {Fragment, memo, useContext} from 'react';
import './Initial.less';

import {ProfileNavigation} from 'compositions/profile-navigation/ProfileNavigation';
import {OrderTypeSelect} from 'compositions/order-type-select/OrderTypeSelect';
import {ListSplitter} from 'elements/list-splitter/ListSplitter.tsx';
import {Card} from "elements/card/Card.tsx";
import {CashPointsDefaultName} from "new-constants/common.constants";
import {ProfileSummary} from "compositions/profile-summary/ProfileSummary";
import {PseudoPagePopup} from "dialog-layout/pseudo-page-popup/PseudoPagePopup";
import {Drawer} from "dialog-layout/drawer/Drawer";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {HeroImage} from "elements/hero-image/HeroImage";
import {CardStyles} from "../../elements/card/Card";

export const INITIAL_POPUP = 'INITIAL_POPUP';


export const Initial = memo(({
															 availableOrderingTypes,
															 isLargeScreen,
															 onOrderingTypeClick,
															 onProfileClick,
															 isShowAddToHomeScreen,
															 onAddToHomeScreenClick,
															 onSettingsClick,

															 currentCustomer,
															 currentActiveOrdersCount = 0,
															 currentRestaurant,
															 currentCashpoints,
															 onUserNameClick,
															 onOffersClick,
															 onCashpointsClick,
															 onOrdersClick,
															 onOverlayClick,

														 }) => {

	const translations = useContext(TranslationsContext);

	const orderTypeSelect = <OrderTypeSelect
		availableOrderingTypes={availableOrderingTypes}
		onOrderingTypeClick={onOrderingTypeClick}
		isLargeScreenOnly
	/>;

	const profileNavigation = <ProfileNavigation
		onProfileClick={onProfileClick}
		isShowAddToHomeScreen={isShowAddToHomeScreen}
		onAddToHomeScreenClick={onAddToHomeScreenClick}
		onSettingsClick={onSettingsClick}
	/>;

	return (
		<PseudoPagePopup
			onOverlayClick={onOverlayClick}
			isInitial
		>
			<div className="initial">
				{
					!isLargeScreen && (
						<div className="initial__image">
							<HeroImage src={currentRestaurant?.picture}/>
						</div>
					)
				}
				<div className="initial__summary">
					<ProfileSummary
						userName={(currentCustomer?.nickname) || getSafeTranslation('InitialPopup.defaultUserName', translations)}
						onUserNameClick={!currentCustomer?.nickname ? onUserNameClick : undefined}
						isShowCashpoints={currentRestaurant && typeof currentRestaurant.cashBackPercentage === 'number' && currentRestaurant.cashBackPercentage > 0}
						cashpointsAmount={currentCashpoints.amount}
						cashpointsName={(currentRestaurant?.cashPointsName) || CashPointsDefaultName}
						ordersCount={currentActiveOrdersCount}
						onOffersClick={onOffersClick}
						onCashpointsClick={onCashpointsClick}
						onOrdersClick={onOrdersClick}
					/>
				</div>
				{
					isLargeScreen ? (
						<Fragment>
							{
								availableOrderingTypes.length > 0 && (
									<div className="initial__order-type-select">
										<Card style={CardStyles.PRIMARY} isNoPaddings>{orderTypeSelect}</Card>
									</div>
								)
							}
							<div className="initial__navigation">
								<Card style={CardStyles.NESTED} isNoPaddings>{profileNavigation}</Card>
							</div>
						</Fragment>
					) : (
						<div className="initial__drawer">
							<Drawer isShowChevron={false}>
								{
									availableOrderingTypes.length > 0 && (
										<div className="initial__order-type-select">
											<Card style={CardStyles.PRIMARY} isNoPaddings>
												{orderTypeSelect}
											</Card>
										</div>
									)
								}
								<div className="initial__navigation">
									<Card style={CardStyles.NESTED} isNoPaddings>
										{profileNavigation}
									</Card>
								</div>
							</Drawer>
						</div>
					)
				}
			</div>
		</PseudoPagePopup>
	);
});
